import { j as e } from "../../../../../node_modules/react/jsx-runtime.js";
import { clsx as f } from "../../../../../node_modules/clsx/dist/clsx.m.js";
import n from "../../../Icon/Icon.js";
import g from "../../../Tooltip/Tooltip.js";
import { Typography as t } from "../../../Typography/Typography.js";
const h = ({
  label: l,
  optionalLabel: r,
  required: s,
  tooltipText: o,
  disabled: i,
  withTextField: m,
  htmlFor: c,
  size: a = "regular"
}) => /* @__PURE__ */ e.jsxs(
  "label",
  {
    htmlFor: c,
    className: f("flex gap-050 items-center", {
      "opacity-disabled cursor-not-allowed": i && !m
    }),
    children: [
      /* @__PURE__ */ e.jsx(
        t,
        {
          text: l,
          variant: a === "regular" ? "interface/medium/sm" : "interface/medium/s",
          textColor: "color/fg/lighter"
        }
      ),
      r && /* @__PURE__ */ e.jsx(
        t,
        {
          text: `(${r})`,
          variant: a === "regular" ? "interface/default/sm" : "interface/default/s",
          textColor: "color/fg/lighter"
        }
      ),
      s && /* @__PURE__ */ e.jsx(
        t,
        {
          text: "*",
          variant: "interface/medium/sm",
          textColor: "color/fg/danger/default"
        }
      ),
      o && /* @__PURE__ */ e.jsx(
        g,
        {
          description: o,
          disabled: i,
          behavior: "tooltip",
          triggerWidth: "fit-content",
          trigger: /* @__PURE__ */ e.jsx(
            n,
            {
              name: "info-circle-filled",
              size: "sm",
              className: "text-color-fg-lightest"
            }
          ),
          placement: "top"
        }
      )
    ]
  }
);
export {
  h as FieldLabel,
  h as default
};
//# sourceMappingURL=FieldLabel.js.map
